<template>
  <v-card class="mb-4">
    <v-card-title class="text-h3">
      Бонусы
    </v-card-title>
    <v-card-text>
      <p v-if="jupiterSync" class="error--text">
        Филиал подключён к Юпитеру — синхронизация бонусов недоступна.
      </p>
      <p v-else-if="startedAt" class="grey--text">
        Синхронизация запускалась {{ startedAtLabel }}. Повторный запуск не нужен.
      </p>
      <v-btn
        color="primary"
        :loading="running"
        :disabled="jupiterSync || !!startedAt"
        @click="showDialog = true"
      >
        Запустить синхронизацию
      </v-btn>
    </v-card-text>

    <primary-confirm-dialog
      v-model="showDialog"
      title="Запустить синхронизацию бонусов?"
      :loading="running"
      @confirm="run"
    >
      <template #subtitle>
        Клиентам филиала, у которых бонусы ещё не сверялись, будут поставлены задачи
        сверки с Юпитером. Они уходят в очередь пачками и выполняются в фоне.
      </template>
    </primary-confirm-dialog>
  </v-card>
</template>

<script>
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import filialConnectionApi from '@/api/administration/filialConnection'
  import { formatIsoDateTimeAsDateTime } from '@/util/date-time-helper'

  export default {
    name: 'FilialConnectionBonusesBlock',
    components: { PrimaryConfirmDialog },
    mixins: [snackbarMessage],
    props: {
      filialId: { type: [Number, String], required: true },
      jupiterSync: { type: Boolean, default: false },
      startedAt: { type: String, default: null },
    },
    data () {
      return {
        running: false,
        showDialog: false,
      }
    },
    computed: {
      startedAtLabel () {
        return formatIsoDateTimeAsDateTime(this.startedAt)
      },
    },
    methods: {
      async run () {
        this.running = true
        try {
          const res = await filialConnectionApi.syncBonuses(this.filialId)
          this.showSuccessMessage(res.message || 'Синхронизация запущена')
          this.$emit('updated')
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.running = false
        this.showDialog = false
      },
    },
  }
</script>
